import React from 'react'
import styled from 'styled-components'
import { Flex, Select, getPaletteColor } from 'pcln-design-system'

const AgeFlex = styled(Flex)`
  svg {
    color: ${getPaletteColor('primary.base')};
  }
`

const selectStyle = {
  border: 'none',
  cursor: 'pointer',
  paddingLeft: 16,
  fontSize: 16,
  fontWeight: 700,
  width: 200
}

export default function ChildAgeSelect({
  childAge,
  childIndex,
  updateAges
}: {
  childAge?: number
  childIndex: number
  updateAges: (age: number, index: number) => void
}) {
  const ageDefaultValue =
    childAge === undefined ? `Add Child ${childIndex + 1}` : childAge
  return (
    <AgeFlex justifyContent="center" my={1}>
      <Select
        defaultValue={ageDefaultValue}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          updateAges(Number(e.target.value), childIndex)
        }}
        name="childAgeSelect"
        style={selectStyle}
        title={`Select age for child ${childIndex + 1}`}
      >
        <option value={-1}>{`Add Child ${childIndex + 1}`}</option>
        <option value={0}>0-1 Infant in lap</option>
        <option value={1}>0-1 Infant in seat</option>
        <option value={2}>2 yrs</option>
        <option value={3}>3 yrs</option>
        <option value={4}>4 yrs</option>
        <option value={5}>5 yrs</option>
        <option value={6}>6 yrs</option>
        <option value={7}>7 yrs</option>
        <option value={8}>8 yrs</option>
        <option value={9}>9 yrs</option>
        <option value={10}>10 yrs</option>
        <option value={11}>11 yrs</option>
        <option value={12}>12 yrs</option>
        <option value={13}>13 yrs</option>
        <option value={14}>14 yrs</option>
        <option value={15}>15 yrs</option>
        <option value={16}>16 yrs</option>
        <option value={17}>17 yrs</option>
      </Select>
    </AgeFlex>
  )
}
